module.exports = __webpack_public_path__ + "static/hero-image-en-49c7b613f90d636d4098c0501c5180cb.svg";